import { Controller } from '@hotwired/stimulus';
import Chart from 'chart.js/auto';
import annotationPlugin from 'chartjs-plugin-annotation'
import 'chartjs-adapter-date-fns'

Chart.register(annotationPlugin)

export default class extends Controller {
  static targets = ['chart']
  static values = {
    stats: Object,
    metric: String,
    from: String,
    to: String
  }

  connect() {
    // const url = new URL(window.location.href) // temporarily removed as a datepicker is disabled
    const from = new Date(this.fromValue)
    const to = new Date(this.toValue)
    let stats = this.statsValue
    let metric = this.metricValue

    // the canvas needs to be cleared from any previous charts before it can be reused for a new chart
    // this behaviour is important when switching the instances
    let previous_chart = Chart.getChart("dashboard-table-chart")
    if (previous_chart) {
      previous_chart.reset()
    }

    let chart = new Chart(this.chartTarget, {
      type: 'line',
      spanGaps: false,
      data: {
        datasets: [
          {
            data: this.getStats(stats, metric),
            borderWidth: 3,
            yAxisID: 'y',
            borderColor: 'rgb(49, 130, 206)',
            tension: 0.2,
            pointRadius: 0,
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          x: {
            grid: {
              display: false,
            },
            type: 'time',
            time: {
              unit: 'day'
            },
            display: false,
            min: new Date(from),
            max: new Date(to)
          },
          y: {
            display: false,
            offset: true
          }
        },
        interaction: {
          mode: 'none',
        },
        plugins: {
          legend: {
            display: false
          }
        }
      }
    })
  }

  getStats(stats, metric) {
    let data = {}
    for (let date in stats) {
      data[date] = stats[date][metric]
    }

    return data
  }
}
